<!--
  列表页统计面板的单项的子项

  使用:
  <lc-summary-sub-item label="金额" :content="money(1)" :label-width="50" />
 -->
<template>
  <div class="lc-summary-sub-item clearfix">
    <div class="item-label pull-left" :style="labelStyle">{{ label }}:</div>
    <div class="item-content pull-left" :class="`lc-${contentStyleType}-color`">
      <!-- 加载时显示空 -->
      <template v-if="loading">-</template>
      <template v-else>{{ content }}</template>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['subLabelWidth', 'summaryItemBus'], // 获取来自父组件的 subLabelWidth
  props: {
    // 标签
    label: {
      type: String,
      default: ''
    },
    // 内容
    content: {
      type: String,
      default: ''
    },
    // 内容的样式类型：success/info/danger/warning
    contentStyleType: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    /**
     * 面板的样式
     *
     * @returns {object} 样式对象
     */
    labelStyle() {
      // 获取父组件传递的 labelWidth
      let parentSubWidth = null
      if (!this.isEmptyObject(this.subLabelWidth)) {
        parentSubWidth = isNaN(this.subLabelWidth) ? this.subLabelWidth : `${this.subLabelWidth}px`
      }

      // 获取自己定义的宽度
      // let widthValue = isNaN(this.labelWidth) ? this.labelWidth : `${this.labelWidth}px`

      return { width: parentSubWidth }
    }
  },
  mounted() {
    this.summaryItemBus.$on('loading-changed', this._onLoadingEvent)
  },
  destroyed() {
    this.summaryItemBus.$off('loading-changed', this._onLoadingEvent)
  },
  methods: {
    /**
     * 收到 Loading 改变的响应
     *
     * @param {boolean} loading 状态
     */
    _onLoadingEvent(loading) {
      this.loading = loading
    }
  }
}
</script>

<style lang="scss" scoped>
// Panel
.lc-summary-sub-item {
  line-height: 20px;

  .item-label {
    font-size: 11px;
    font-weight: 400;
    color: #606266;
  }

  .item-content {
    font-size: 11px;
    font-weight: 500;
    color: #303133;
  }
}
</style>
